import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { Importance } from '@sb-tools/typescript/enums/importance.enum';
import { takeUntil } from 'rxjs/operators';
import { TicketService } from '../../core/services/ticket/ticket.service';
import { Subject } from 'rxjs';
import { DetailedTicketDTO } from '../../core/models/dto/detailed-ticket.dto';
import { InlineSVGComponent } from '../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { NgClass } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-importance',
    templateUrl: './importance.component.html',
    styleUrls: ['./importance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InlineSVGComponent, NgClass, BsDropdownModule, TranslateModule],
})
export class ImportanceComponent implements OnDestroy {
    @Input() importance: Importance;
    @Input() ticket: DetailedTicketDTO;

    importanceEnum = Importance;

    private unsubscriber = new Subject<void>();

    constructor(
        public commonDataService: CommonDataService,
        private ticketService: TicketService,
    ) {}

    updatePriority(importance) {
        this.ticketService
            .changeImportance(this.ticket.id, importance)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.ticket.importance = importance;
            });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
